export default {
    activeTab: null,
    selectedPlan: null,
    pricingEssentialsMounted: false,
    products: [],
    featureGroups: [],
    testimonials: [],
    faqs: [],
    plans: [],
    proFeatures: [],
    gender: '',
    sport: '',
    rosterNeedsEnabled: false
};
